import AnnotationLayer from "../layers/AnnotationLayer";
import {tileViewApp} from "../app_maker";
import Line from "../drawTools/Line";
import FreeLine from "../drawTools/FreeLine";
import Circle from "../drawTools/Circle";
import FreeHand from "../drawTools/FreeHand";
import Rectangle from "../drawTools/Rectangle";
import Polygon from "../drawTools/Polygon";

class TileAnnotationLayer extends AnnotationLayer {

    id = tileViewApp.id;
    label = "Tile Annotation Layer";
    drawer = tileViewApp.drawer;
    tools = [Line, FreeLine, Circle, FreeHand, Rectangle, Polygon];
}

export default TileAnnotationLayer;